/* projects/shared/src/lib/components/forms/field-error-message/field-error-message.component.scss */
:host {
  display: block;
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}
/*# sourceMappingURL=field-error-message.component.css.map */
